import { Box, Center, Checkbox, Flex, Image, Input, InputGroup, InputLeftElement, SimpleGrid, Spinner, Text, useDisclosure, useToast, } from "@chakra-ui/react";
import CustomTable from "components/Table/CustomTable";
import React, { useCallback, useEffect, useState } from "react";
import GreenPlus from "components/Icons/Common/GreenPlus.svg";
import { Link, useSearchParams } from "react-router-dom";
import { useAppSelector } from "hooks/store/hooks";
import { selectColorThemeMode, setLoader } from "stores/uiSlice";
import PageSelector from "components/Table/PageSelector";
import Pagination from "components/Table/Pagination";
import apiHelper from "services/apiHelper";
import CustomToast from "components/CustomToast";
import DeleteIcon from "components/Icons/Common/DeleteIcon.svg";
import EditIcon from "components/Icons/Common/EditIcon.svg";
import pendingIcon from "components/Icons/Common/pendingIcon.svg";
import moment from "moment";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import DeleteModal from "components/Modals/deleteModal";
import { deleteMediaFromS3Bucket } from "services/awsHelper";
import { SearchIcon } from "@chakra-ui/icons";
import debounce from "lodash.debounce"
import { ExportToExcel } from "services/excelHelper";
import usePaginatedProducts from "api/products";


const ProductsPage = () => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const [selectedProduct, setselectedProduct] = useState(undefined);

  const {
    isOpen: isOpenDeleteModal,
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
  } = useDisclosure();

  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useToast();
  const dispatch = useDispatch();
  const [tableTab, setTableTab] = useState("All Projects");
  const [searchDataShowing, setSearchDataShowing] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [state, setState] = useState({
    fields: parseInt(searchParams.get("fields") || "") || "",
    sort: parseInt(searchParams.get("sort") || "") || "",
    page: parseInt(searchParams.get("page") || "1") || 1,
    limit: parseInt(searchParams.get("limit") || "100") || 100,
  });

  const TABLE_TAB = [
    "All Projects",
    "Pending",
    "Approved",
    "Rejected",
    "Re-Submitted",
  ];

  const checkboxOperations = (checked, Row) => {
    if (checked) {
      setSelectedRows([...selectedRows, Row]);
    } else {
      let newArray = selectedRows.filter(row => row._id !== Row._id)
      setSelectedRows(newArray);
    }
  }

  const onHeaderCheckboxChange = (checked) => {
    if (checked) {
      let data = projectData?.data?.length > 0 ? projectData.data : []
      setSelectedRows(data)
    } else {
      setSelectedRows([])
    }
  }


  const productsColumn = [
    {
      name: (
        <>
          <Checkbox
            colorScheme="green"
            className={"custom__checkbox"}
            fontWeight={500}
            onChange={(e) => onHeaderCheckboxChange(e.target.checked)}
            ml={2}
          >
          </Checkbox>
        </>
      ),
      width: "60px",
      cell: (row) => (
        <>
          <Checkbox
            colorScheme="green"
            className={"custom__checkbox"}
            mr={"20px"}
            fontWeight={500}
            onChange={(e) => checkboxOperations(e.target.checked, row)}
            ml={2}
            isChecked={selectedRows.filter(Row => Row._id === row._id).length > 0}
          >
          </Checkbox>
        </>
      ),
    },
    {
      name: "PR No.",
      width: "100px",
      selector: row => row.serialNumber,
      sortable: true,
      cell: (row) => (
        <>
          <Text ml={3}>
            {`#PJ${row.serialNumber <= 9 ? "0" : ""}${row.serialNumber}`}
          </Text>
        </>
      ),
    },
    {
      name: "Image",
      width: "150px",
      cell: (row) => (
        <>
          <Box p={3}>
            {row.coverImage ?
              <Image height={"70px"} width={"70px"} borderRadius={"8px"} src={`${process.env.REACT_APP_IMAGE_API_URL}${row.coverImage}`} />
              : '-'}
          </Box>
        </>
      ),
    },
    {
      name: "Title",
      width: "250px",
      selector: row => row.name,
      sortable: true,
      cell: (row) => (
        <>
          <Text
            as={Link}
            to={`/products/${row._id}`}
            color={`${colorThemeMode}_primary`}
            ml={1}
          >
            {row.name}
          </Text>
        </>
      ),
    },
    {
      name: "Clicks",
      width: "120px",
      selector: row => row.clicks,
      cell: (row) => (
        <>
          <Text ml={3}>{`${row.clicks ? row.clicks : "0"}`} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "Inquiry",
      width: "120px",
      selector: row => row.inquiry ? row.inquiry : "0",
      cell: (row) => (
        <>
          <Text ml={3}>{`${row.inquiry ? row.inquiry : "0"}`} </Text>
        </>
      ),
      sortable: true
    },

    {
      name: "Date",
      width: "120px",
      selector: row => row.createdAt,
      cell: (row) => (
        <>
          <Text ml={1}> {moment(row.createdAt).format("DD/MM/YY hh:mm:ss A")} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "Price",
      width: "120px",
      selector: row => row.price,
      cell: (row) => (
        <>
          <Text ml={3}>{row.price} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "MRP",
      width: "120px",
      selector: row => row.mrpPrice,
      cell: (row) => (
        <>
          <Text ml={3}>{row.mrpPrice} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "Category",
      width: "200px",
      selector: row => row.category?.category,
      cell: (row) => (
        <>
          <Text ml={3}>{row.category?.category ?? "-"} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "Sub-Category",
      width: "200px",
      selector: row => row.subCategory?.subCategory,
      cell: (row) => (
        <>
          <Text ml={3}>{row.subCategory?.subCategory ?? "-"} </Text>
        </>
      ),
      sortable: true
    },
    {
      name: "Status",
      width: "200px",
      selector: row => row.approvalStatus,
      cell: (row) =>
        row.approvalStatus === "Approved" ? (
          <Box
            bg={"#01B763"}
            color={"#fff"}
            borderRadius={"24px"}
            px={"10%"}
            py={"2%"}
          >
            Approved
          </Box>
        ) : row.approvalStatus === "Pending" ? (
          <Box
            bg={"#FF981F"}
            color={"#fff"}
            borderRadius={"24px"}
            px={"10%"}
            py={"2%"}
          >
            <Flex></Flex>Pending
          </Box>
        ) : row.approvalStatus === "Rejected" ? (
          <Box
            bg={"#F75555"}
            color={"#fff"}
            borderRadius={"24px"}
            px={"10%"}
            py={"2%"}
          >
            <Flex gap={"5px"}>
              Rejected<Image src={pendingIcon}></Image>
            </Flex>
          </Box>
        ) : row.approvalStatus === "Re-Submitted" ? (
          <Box
            bg={"#FF981F"}
            color={"#fff"}
            borderRadius={"24px"}
            px={"10%"}
            py={"2%"}
          >
            <Flex gap={"5px"}>
              Re-Submitted<Image src={pendingIcon}></Image>
            </Flex>
          </Box>
        ) : (
          <></>
        ),
      sortable: true
    },
    {
      name: "Actions",
      width: "100px",
      id: "actions",
      cell: (row) => (
        <>
          <Flex gap={"15px"}>
            <Box cursor={"pointer"} as={Link} to={`/products/${row._id}`}>
              <Image src={EditIcon}></Image>
            </Box>
            <Box
              cursor={"pointer"}
              onClick={() => {
                setselectedProduct(row);
                onOpenDeleteModal();
              }}
            >
              <Image src={DeleteIcon}></Image>
            </Box>
          </Flex>
        </>
      ),
    },
  ];

  useEffect(() => {
    setSearchParams(
      Object.entries(state).map((e) => {
        return [e[0], `${e[1]}`];
      })
    );
  }, [setSearchParams, state]);


  const reducer = useCallback((newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  }, []);


  const handleChangeQuery = (key, value) => {
    setState({
      ...state,
      [key]: value,
    });
  };

  const removeApprovalStatus = useCallback(() => {
    const query = { ...state };
    delete query.approvalStatus;
    setState({ ...query });
  });

  const query = queryString.stringify(state);

  const {
    data: projectData,
    mutate,
    isLoading,
  } = usePaginatedProducts({
    query: query,
    fields: state.fields,
    sort: state.sort,
    page: state.page,
    limit: state.limit,
  });



  const removeproductMediaFroms3 = () => {
    [selectedProduct.coverImage, ...selectedProduct.productImages].forEach(
      (media) => {
        deleteMediaFromS3Bucket(media);
      }
    );
  };

  const handleDeleteProject = async () => {
    dispatch(setLoader(true));

    await apiHelper(`api/v1/product/delete_product/${selectedProduct._id}`, "delete", null, {})
      .then((res) => {
        mutate();
        <CustomToast
          title={"Success"}
          message={"Project Deleted Successfully!"}
        />
        removeproductMediaFroms3();
        setselectedProduct(undefined);
        onCloseDeleteModal();
        dispatch(setLoader(false));
      })
      .catch((error) => {
        dispatch(setLoader(false));
        toast({
          status: "error",
          render: () => <CustomToast title={"Error"} message={error.message} />,
        });
      });
  };

  const handleBulkDelete = async () => {

    for (const row of selectedRows) {
      await apiHelper(`api/v1/product/delete_product/${row._id}`, "delete", null, {});
      [row.coverImage, ...row.productImages].forEach(
        async (media) => {
          await deleteMediaFromS3Bucket(media);
        }
      );

    }
    setSelectedRows([]);
    mutate();

  }

  const executeSearch = (searchString) => {
    if (searchString.length >= 3) {
      setState({ search: 'name', searchValue: searchString })
      setSearchDataShowing(true);
    } else {
      setState({
        fields: parseInt(searchParams.get("fields") || "") || "",
        sort: parseInt(searchParams.get("sort") || "") || "",
        page: parseInt(searchParams.get("page") || "1") || 1,
        limit: parseInt(searchParams.get("limit") || "100") || 100,
      });
      setSearchDataShowing(false);
    }
  }

  const formatData = (data) => {
    return data.map(row => ({
      "PR No.": `#PR${row.serialNumber <= 9 ? "0" : ""}${row.serialNumber}`,
      Title: row.name,
      price: row.price,
      MRP: row.mrpPrice,
      "Post By": `${row.createdBy.firstName} ${row.createdBy.lastName}`,
      Date: moment(row.createdAt).format('DD/MM/YYYY'),
      Status: row.live ? "Active" : "InActive",
      "Approval-Status": row.approvalStatus,
    }));
  };


  const exportToExcel = () => {
    let data = selectedRows.length > 0 ? selectedRows : projectData?.data?.length > 0 ? projectData.data : [];
    const formattedData = formatData(data)
    ExportToExcel(formattedData, 'Projects')
  };

  return (
    <>
      <Box>

        <Box
          bg={"#ffffff"}
          borderRadius={"12px"}
          boxShadow={"0px 8px 24px 0px rgba(0, 0, 0, 0.08)"}
          overflow={"hidden"}
          minH={"auto"}
        >
          <Box
            display={"flex"}
            alignItems={"flex-start"}
            justifyContent={"space-between"}
            borderBottom={"1px solid #C9C9C9"}
          >
            <SimpleGrid columns={{ base: 3, lg: 5 }}>
              {TABLE_TAB.map((item) => {
                return (
                  <Box
                    minW={"fit-content"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    // width={"190px"}
                    cursor={"pointer"}
                    p={"12px 10px"}
                    fontSize={"18px"}
                    fontWeight={500}
                    bgColor={tableTab === item ? "#CAD7D0" : ""}
                    borderBottom={
                      tableTab === item
                        ? "1px solid #1C5E3C"
                        : "1px solid #ffffff"
                    }
                    onClick={() => {
                      setTableTab(item);
                      if (item === "All Projects") {
                        removeApprovalStatus();
                      } else {
                        handleChangeQuery("approvalStatus", item);
                      }
                    }}
                    textAlign={"center"}
                  >
                    <Text mr={"10px"}>{item}</Text>
                    {!isLoading && tableTab === item && (
                      <Text whiteSpace={"nowrap"}>{projectData?.results}</Text>
                    )}
                  </Box>
                );
              })}
            </SimpleGrid>
            <Box
              as={Link}
              to={"new"}
              cursor={"pointer"}
              p={"12px 24px 13px"}
              fontSize={"18px"}
              fontWeight={500}
              bgColor={"#CAD7D0"}
              display={"flex"}
              height={"100%"}
              color={"#212121"}
            >
              <Image src={GreenPlus} mr={"10px"} /> Create Product
            </Box>
          </Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"end"}
            p={"20px"}
            position={"relative"}
          >
            {selectedRows.length > 0 && <Text mr={3}>Selected: {selectedRows.length}</Text>}

            <InputGroup alignItems={"center"} flex={1}>
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='green' />
              </InputLeftElement>
              <Input type='text' placeholder='Search' border={"2px solid #C9C9C9"} borderRadius={"48px"} _placeholder={{ fontsize: "16px", color: "#1C5E3C", fontWeight: 500 }}
                onChange={debounce(e => { executeSearch(e.target.value) }, 500)}
              />
            </InputGroup>

            {/* <Flex ml={3} border={`2px solid ${showFilter ? "#739A86" : "#C9C9C9"}`} bg={showFilter ? "#1C5E3C" : "transparent"} borderRadius={"48px"} paddingY={"12px"} paddingX={"20px"} cursor={"pointer"} onClick={() => setFilter(!showFilter)} >
              <Text fontSize={"16px"} color={showFilter ? "#fff" : "#1C5E3C"} fontWeight={500}>Filters</Text>
              <Image src={showFilter ? FilterWhiteIcon : FilterIcon} ml={"10px"} />
            </Flex> */}

            <Box border={"2px solid #C9C9C9"} borderRadius={"48px"} paddingY={"12px"} paddingX={"20px"} cursor={"pointer"} ml={3} fontSize={"16px"} color={"#1C5E3C"} fontWeight={500}
              transition={"0.3s ease"}
              _hover={{ bg: "#1C5E3C", color: "#fff", border: "2px solid #739A86" }}
              onClick={exportToExcel}>
              Export to Excel
            </Box>
            {selectedRows.length > 0 && <Image src={DeleteIcon} ml={3} onClick={handleBulkDelete}></Image>}

          </Box>
          {(!isLoading) ? (
            <>
              <CustomTable data={projectData?.data} columns={productsColumn} />

              {(!searchDataShowing) && <Box p="10px" display="flex" justifyContent="flex-end">
                <PageSelector
                  pageSize={state.limit}
                  setPageSize={(newVal) => reducer({ limit: newVal })}
                  setPageNumber={(newVal) => reducer({ page: newVal })}
                />
                <Pagination
                  pageSize={state.limit}
                  pageNumber={state.page}
                  setPageNumber={(newVal) => reducer({ page: newVal })}
                  totalElements={projectData?.results || 0}
                />
              </Box>}
            </>
          ) : (
            <Center h={"500px"}>
              <Spinner />
            </Center>
          )}
        </Box>
      </Box>

      <DeleteModal
        showModal={isOpenDeleteModal}
        OnClose={() => {
          setselectedProduct(undefined);
          onCloseDeleteModal();
        }}
        categoryTitle={"Product"}
        title={selectedProduct?.name}
        deleteFunction={handleDeleteProject}
      />
    </>
  );
};

export default ProductsPage;
